import { Button } from "../components/ui/button";
import heroImage from "../assets/hero-ar-infrastructure.jpg";

export const Hero = () => {

  const hero = {
    "title": "See Your Infrastructure Data in Augmented Reality",
    "subtitle": "FoundAt brings GO-Locate AR™ to infrastructure owners and field teams. Visualize all forms of data for underground utilities, building systems, and assets precisely where they exist in the real world—no GPS coordinates.",
    "requestDemo": "Request a Demo",
    "seeUseCases": "See Use Cases",
    "seeItInAction": "See it in Action",
    "remoteAR": "Remote AR Placement",
    "indoorOutdoor": "Indoor & Outdoor Capability",
    "enterpriseSecurity": "Enterprise-Grade Security"
  }

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Infrastructure worker using AR technology"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/80 to-primary/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-white to-home-accent/50 bg-white bg-clip-text text-transparent mb-6 leading-tight">
            {hero.title}
          </h1>
          <p className="text-xl text-white mb-8 leading-relaxed">
            {hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button onClick={() => scrollToSection("demo")} variant="hero" size="lg">
              {hero.requestDemo}
            </Button>
            <Button onClick={() => scrollToSection("use-cases")} variant="outline" size="lg">
              {hero.seeItInAction}
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 pt-8">
            <p className="text-sm text-home-muted-foreground mb-4">
              Trusted by infrastructure owners and operators globally
            </p>
            <div className="flex flex-wrap gap-6 items-center">
              <div className="flex items-center gap-2">
                <span className="relative my-auto flex size-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-home-accent opacity-75"></span>
                    <span className="relative inline-flex size-2 rounded-full bg-home-accent"></span>
                </span>
                <span className="text-sm text-white">{hero.remoteAR}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="relative my-auto flex size-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-home-accent opacity-75"></span>
                    <span className="relative inline-flex size-2 rounded-full bg-home-accent"></span>
                </span>
                <span className="text-sm text-white">{hero.indoorOutdoor}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="relative my-auto flex size-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-home-accent opacity-75"></span>
                    <span className="relative inline-flex size-2 rounded-full bg-home-accent"></span>
                </span>
                <span className="text-sm text-white">{hero.enterpriseSecurity}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
